import { render, staticRenderFns } from "./DocumentListing.vue?vue&type=template&id=59ae910e&"
import script from "./DocumentListing.vue?vue&type=script&lang=js&"
export * from "./DocumentListing.vue?vue&type=script&lang=js&"
import style0 from "./DocumentListing.vue?vue&type=style&index=0&id=59ae910e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports